"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TEXT = void 0;
const tab_1 = require("../../../tab");
exports.TEXT = {
    description: 'Converts a number, date or datetime into text according to a specified format.',
    arg_names: ['string_to_transform', 'layout', 'locale'],
    args_def: [
        {
            types: ['string', 'number', 'int', 'date'],
            required: true,
        },
        {
            types: ['string'],
            required: true,
        },
        {
            types: ['string'],
            required: false,
        },
    ],
    args_description: [
        'string to transform',
        'layout - Examples: HH:mm; hh:mm; hh:mm:ss; R$#,###.00; $0.00; 0%; 0.0%; #.#%; mmmm-dd-yyyy, hh:mm A/P; mm/dd,yyyy; #,###; 0.00; #.##',
        'locale to be used',
    ],
    return_type: tab_1.ColumnType.STRING,
};
